import api from './api';

export const globalSearch = async (params = {}) => {
  const response = await api.get('/search', { params });
  return response.data;
};

export const advancedDocumentSearch = async (params = {}) => {
  const response = await api.get('/search/documents', { params });
  return response.data;
};
